import { useStorePlanningWeek } from '@gozoki/api'
import { useState } from 'react'
import { ChevronRightRoundIcon } from './icons/LayerIcon'
import { PlanningWeekModal } from './PlanningWeekModal'
import { PlanningGrid } from './planning/PlanningGrid'
import { PlanningLegend } from './planning/PlanningLegend'
import { CalendarIcon } from './planning/planning-icons'

export function PlanningWeekCard() {
  const { data, isLoading } = useStorePlanningWeek()
  const [isDetailOpen, setIsDetailOpen] = useState(false)

  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-[16px] overflow-hidden rounded-[24px] bg-[#F0EDE2] p-[17px]">
      <div className="flex h-[40px] items-center gap-[12px]">
        <div className="flex shrink-0 items-center gap-[8px]">
          <span className="flex size-[40px] items-center justify-center rounded-[12px] bg-[#F9F8F1] text-[#4F6A47]">
            <CalendarIcon />
          </span>
          <h2 className="font-brand text-[22px] leading-[26px] font-semibold whitespace-nowrap text-[#4F6A47] uppercase">
            Planning semaine en cours
          </h2>
        </div>

        {/* Ouvre le détail plein écran (modale). */}
        <button
          type="button"
          aria-label="Ouvrir le détail du planning"
          onClick={() => setIsDetailOpen(true)}
          className="shrink-0 cursor-pointer text-[#4F6A47]"
        >
          <ChevronRightRoundIcon />
        </button>

        <span className="h-px min-w-0 flex-1 bg-[#0000000F]" />

        <PlanningLegend />
      </div>

      {data ? (
        <PlanningGrid days={data.days} affluenceMax={data.affluenceMax} centerOnNow />
      ) : (
        <div className="flex min-h-0 flex-1 items-center justify-center text-sm text-[#8A8676]">
          {isLoading ? 'Chargement…' : 'Aucune donnée'}
        </div>
      )}

      {isDetailOpen ? <PlanningWeekModal onClose={() => setIsDetailOpen(false)} /> : null}
    </div>
  )
}
